const getToken = () => {
    return JSON.parse(localStorage.getItem("key"));
};
const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    authorization: "",
};
export const getCompandy = () => async (dispatch) => { 
    let SERVER_URL = process.env.REACT_APP_API_URL;
    await fetch(SERVER_URL + `api/common/company_list`, {
        method: "GET",
        headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
    })
        .then((res) => res.json())
        .then((data) => {
            //console.log(data);return false;
        dispatch({
            type: "GET_COMPANY",
            payload: data.result,
        });
    });
};
export const getNewCondidateList = () => async (dispatch) => { 
    let SERVER_URL = process.env.REACT_APP_API_URL;
    await fetch(SERVER_URL + `api/candidate/all`, {
        method: "GET",
        headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
    })
        .then((res) => res.json())
        .then((data) => {
            //console.log(data);return false;
        dispatch({
            type: "GET_NEWJOINER",
            payload: data.data,
        });
    });
};
export const getSingleCondidate = (email) => async (dispatch) => { 
   
    let SERVER_URL = process.env.REACT_APP_API_URL;
    await fetch(SERVER_URL + `api/candidate/new/joinerDetail`, {
        method: "post",
        headers: { ...headers },
        body:JSON.stringify({
            email:email,
        })
    })
        .then((res) => res.json())
        .then((data) => {
//console.log(data)
        dispatch({
            type: "GET_SINGEL_DETAILS",
            payload: data.data,
        });
    });
};
export const getNewFamilyList = (id) => async (dispatch) => { 
    let SERVER_URL = process.env.REACT_APP_API_URL;
    await fetch(SERVER_URL + `api/candidate/single/familyList/${id}`, {
        method: "GET",
        headers: { ...headers },
    })
        .then((res) => res.json())
        .then((data) => {
            //console.log(data);return false;
        dispatch({
            type: "GET_NEWJOINER_FAMILY_LIST",
            payload: data.data,
        });
    });
};
export const getNewCondidateQualificationList = (id) => async (dispatch) => { 
    let SERVER_URL = process.env.REACT_APP_API_URL;
    await fetch(SERVER_URL + `api/candidate/onboarding/single/QualificationList/${id}`, {
        method: "GET",
        headers: { ...headers },
    })
        .then((res) => res.json())
        .then((data) => {
            //console.log(data);return false;
        dispatch({
            type: "GET_QUALICATION_LIST",
            payload: data.data,
        });
    });
};
export const getNewCondidatePreviousEmpDetailsList = (id) => async (dispatch) => { 
    let SERVER_URL = process.env.REACT_APP_API_URL;
    await fetch(SERVER_URL + `api/candidate/onboarding/single/PreviousEmpList/${id}`, {
        method: "GET",
        headers: { ...headers },
    })
        .then((res) => res.json())
        .then((data) => {
            //console.log(data);return false;
        dispatch({
            type: "GET_PREVIOUS_EMP_LIST",
            payload: data.data,
        });
    });
};